import React from "react";
import PropTypes from "prop-types";

import { Wrapper, Card } from "app/NativeComponents/common";
import { MenuItem } from "app/NativeComponents/snippets";

const ProfileOptions = props => {
  const { user, colors, appRedirect } = props;

  return (
    <Wrapper>
      <Card>
        <MenuItem
          style={{
            borderBottomWidth: 1,
            borderBottomColor: colors.border_color,
            borderBottomStyle: "solid"
          }}
          to="/a/settings/account"
          onPress={() => appRedirect({ redirect: "account" })}
          title="Profile"
          text={user.email}
        />
        {user.team_clearance_level >= 2 || user.team_owner == 1 ? (
          <MenuItem
            style={{
              borderBottomWidth: 1,
              borderBottomColor: colors.border_color,
              borderBottomStyle: "solid"
            }}
            to="/a/settings/engines-and-addons"
            onPress={() => appRedirect({ redirect: "enginesAndAddons" })}
            title="Engines & Add-ons"
            text={"View and manage your DealMachine Engines and features"}
          />
        ) : null}
      </Card>
    </Wrapper>
  );
};

ProfileOptions.propTypes = {
  user: PropTypes.object,
  colors: PropTypes.object,
  appRedirect: PropTypes.func
};

export default ProfileOptions;
